export enum SystemEventParentType {
    USER = 1,
    ROLE = 2,
    PRODUCT_FEATURE = 3,
}
